import { Platform } from '@cart-services/hooks/fp-b2b/store-map'
import { type PropsWithChildren, useCallback, useEffect } from 'react'
import { ButlerProvider } from '../../fp-b2b-shared/ai-purchase-order/components/ButlerProvider/ButlerProvider'
import { RefreshButlerToken } from '../../fp-b2b-shared/ai-purchase-order/components/RefreshButlerToken/RefreshButlerToken'
import { LoaderStm } from '../components/LoaderStm'
import { useActiveBrands, useStmBrandStore, useStmQuickOrderStore } from '../hooks'

export interface StmQuickOrderProviderProps {
  basePath: string
}

export const StmQuickOrderProvider = (props: PropsWithChildren<StmQuickOrderProviderProps>) => {
  const { basePath, children } = props
  const activeBrands = useActiveBrands()
  const selectedProjectCode = useStmQuickOrderStore(state => state.selectedProjectCode)
  const selectedTab = useStmQuickOrderStore(state => state.selectedTab)
  const setSelectedTab = useStmQuickOrderStore(state => state.setSelectedTab)
  const setSelectedProjectCode = useStmQuickOrderStore(state => state.setSelectedProjectCode)
  const setBrand = useStmBrandStore(state => state.setBrand)
  const brand = activeBrands.find(activeBrand => activeBrand.projectCode === selectedProjectCode) ?? activeBrands[0]
  const brandProjectCode = brand?.projectCode
  const brandCampaignCode = brand?.campaignCode

  // 預設品牌不一定在使用者的有效品牌內，回寫實際採用的品牌讓 BrandSelect 與建單品牌一致
  useEffect(function syncSelectedProjectCodeToActiveBrand() {
    if (brandProjectCode && brandProjectCode !== selectedProjectCode) setSelectedProjectCode(brandProjectCode)
  }, [brandProjectCode, selectedProjectCode, setSelectedProjectCode])

  // 建單品牌（BrandSelect）與購物車頁的品牌 tab 是兩個 store，加入後把購物車頁切到剛寫入的品牌
  const selectBrandForCart = useCallback(() => {
    if (brandCampaignCode) setBrand(brandCampaignCode)
  }, [brandCampaignCode, setBrand])

  if (!brand) return <LoaderStm />

  return (
    <>
      <RefreshButlerToken projectCode={brand.projectCode} campaignCode={brand.campaignCode} />
      <ButlerProvider
        platform={Platform.STM}
        projectCode={brand.projectCode}
        countryCode={brand.countryCode}
        campaignId={brand.campaignId}
        campaignCode={brand.campaignCode}
        basePath={basePath}
        selectedTab={selectedTab}
        onSelectedTabChange={setSelectedTab}
        onAddToCartSuccess={selectBrandForCart}
      >
        {children}
      </ButlerProvider>
    </>
  )
}
